import { Component, OnInit, Inject } from '@angular/core';
import { CommonService } from "../../_services/common.service";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { ProductModelPhotoComponent } from '../product-model-photo/product-model-photo.component';
import { Router } from '@angular/router';
import { forEach } from '@angular/router/src/utils/collection';

export interface DialogData {
  productId: string,
  price: string,
  pageType: string,
  selectedProductColor: Array<any>,
  is_public_url: string,
  matrixId: string
}

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.css']
})
export class ProductDetailComponent implements OnInit {
  public loading = false; 
  public productOptions: any = {};
  public productDetails: any = {};
  public productImages: any = {};
  public displayMainImage: string;
  public colorStyleObj: string;
  public currentActiveColor = null;
  public activeProjectIndex = 0;
  public selectedProductColors = {};
  public selectedProductPrice = {};
  public currentProductId = "";
  public isAlreadyExist = false;
  public projects: any = {};
  public currentActiveColorObj: any = {};
  public selectedColors: any = [];
  public id: string;
  public orderStatus: string;
  public userDetails: any = {};
  public productMatrix: any = [];
  public isPublicQuoteCreation = false;
  public isactionBar = false;
  constructor(public dialogRef: MatDialogRef<ProductDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private CommonService: CommonService,
    private CommonProjectDataService: CommonProjectDataService,
    private dialog: MatDialog,
    private router: Router
  ) { 
    this.isPublicQuoteCreation = localStorage.getItem('isPublicQuoteCreation') === 'Yes' ? true : false;
  }

  ngOnInit() {
    this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
    if (this.data.is_public_url == 'Yes') {
      this.id = localStorage.getItem("shopID");
    }
    else {
      if (this.userDetails.type == "Shop") {
        this.id = localStorage.getItem("userID");
      } else if (this.userDetails.type == "Designer" || this.userDetails.type == "Printer") {
        this.id = this.userDetails.shop_id;
      } else {
        this.id = localStorage.getItem("shopID");
      }
    }
    this.orderStatus = this.CommonProjectDataService.getOrderType();
    this.selectedProductColors = this.CommonProjectDataService.getProductColor() ? JSON.parse(JSON.stringify(this.CommonProjectDataService.getProductColor())) : {};
    this.activeProjectIndex = this.CommonProjectDataService.getActiveProjectIndex() ? parseInt(this.CommonProjectDataService.getActiveProjectIndex()) : 0;
    this.projects = JSON.parse(JSON.stringify(this.CommonProjectDataService.get()));
    this.currentProductId = this.data.productId;
    this.selectedColors = (this.selectedProductColors[0] && this.selectedProductColors[0][this.currentProductId]) ? this.selectedProductColors[0][this.currentProductId] : this.selectedColors;
    this.selectedProductPrice = this.CommonProjectDataService.getSelectedProductPrice() ? JSON.parse(JSON.stringify(this.CommonProjectDataService.getSelectedProductPrice())) : {};
    this.getProductDetail();
    this.productMatrix = this.CommonProjectDataService.getProductMatrix();
    this.isactionBar = !(this.projects.type == 'Invoice' && this.projects.isInvoiceEditable === 0) ? true : false;
    this.isactionBar = this.data.is_public_url == 'Yes' ? false : this.isactionBar;
  }

  getProductDetail = function () {
    this.loading = true;
    this.productOptions = {
      id: this.id,
      product_id: this.data.productId,
      no_ordered_value: true
    };
    this.CommonService.apiService(
      "POST",
      "product",
      this.productOptions
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          this.productDetails = response.data;
          if (this.productDetails.type == 'quickItem') {
            this.data.price = this.getFirstPrice(this.productDetails.options);
          }
          
          this.CommonProjectDataService.storeIsLessOrderLimit(response.data.less_order_limit);
          if (this.data.selectedProductColor) {
            this.handleColorImage(this.data.selectedProductColor);
          }
          else {
            this.productImages = {
              'front_image': (response.data.colors[0].front_image) ? response.data.colors[0].front_image : this.productDetails.style_image,
              'side_image': (response.data.colors[0].side_image) ? response.data.colors[0].side_image : this.productDetails.style_image,
              'back_image': (response.data.colors[0].back_image) ? response.data.colors[0].back_image : this.productDetails.style_image,
              'direct_side': (response.data.colors[0].direct_side) ? response.data.colors[0].direct_side : null,
              'model_front': (response.data.colors[0].model_front) ? response.data.colors[0].model_front : null,
              'model_side': (response.data.colors[0].model_side) ? response.data.colors[0].model_side : null,
              'model_back': (response.data.colors[0].back_image) ? response.data.colors[0].model_back : null,
            }
            this.displayMainImage = (response.data.colors[0].front_image) ? response.data.colors[0].front_image : this.productDetails.style_image;
            this.displayMainImage = this.displayMainImage.replace('_fm.', '_fl.');
            this.displayMainImage = this.displayMainImage.replace('//cdnl.', '//cdnm.');
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  onNoClick(): void {
    this.dialogRef.close();

  }

  showFullImage(imgSrc) {
    this.displayMainImage = imgSrc.replace('_fm.', '_fl.');
    this.displayMainImage = imgSrc.replace('//cdnl.', '//cdnm.');
  }

  checkActiveColor(colorId) {
    return this.currentActiveColor == colorId;
  }

  activeAdded(colorId) {
    return (this.selectedProductColors[this.activeProjectIndex] && this.selectedProductColors[this.activeProjectIndex][this.currentProductId] && this.selectedProductColors[this.activeProjectIndex][this.currentProductId].indexOf(colorId) >= 0) ? true : false;
  }

  handleColorImage = function (selData) {
    this.productImages = {
      'front_image': (selData.front_image) ? selData.front_image : this.productDetails.style_image,
      'side_image': (selData.side_image) ? selData.side_image : this.productDetails.style_image,
      'back_image': (selData.back_image) ? selData.back_image : this.productDetails.style_image,
      'direct_side': (selData.direct_side) ? selData.direct_side : null,
      'model_front': (selData.model_front) ? selData.model_front : null,
      'model_side': (selData.model_side) ? selData.model_side : null,
      'model_back': (selData.back_image) ? selData.model_back : null
    }
    this.displayMainImage = (selData.front_image) ? selData.front_image : this.productDetails.style_image;
    this.displayMainImage = this.displayMainImage.replace('_fm.', '_fl.');
    this.displayMainImage = this.displayMainImage.replace('//cdnl.', '//cdnm.');
    this.currentActiveColor = selData.color_id;
    this.currentActiveColorObj = selData;

    //check already exits
    if ((this.selectedProductColors[this.activeProjectIndex] && this.selectedProductColors[this.activeProjectIndex][this.currentProductId] && this.selectedProductColors[this.activeProjectIndex][this.currentProductId].indexOf(selData.color_id) >= 0)) {

      this.isAlreadyExist = true;
    }
    else {
      this.isAlreadyExist = false;
    }
  }

  manageSelectedColors(isAlreadyExist) {
    if (this.currentActiveColor) {
      //handle projects
      if (isAlreadyExist) {

        this.projects.projects_data[this.activeProjectIndex]['products'].forEach((value, key) => {
          if (value.product_id == this.productDetails.product_id) {
            this.projects.projects_data[this.activeProjectIndex]['products'][key].matrix.forEach((ivalue, ikey) => {
              if (ivalue.color.color_id == this.currentActiveColor) {
                this.projects.projects_data[this.activeProjectIndex]['products'][key].matrix.splice(ikey, 1);
              }
            });
          }
        });
      }
      else {
        if (!this.projects.projects_data[this.activeProjectIndex]['products']) {
          let pdesc = this.productDetails;
          this.projects.projects_data[this.activeProjectIndex]['products'] = [{
            'product_id': this.productDetails.product_id,
            'productDetail': pdesc,
            'matrix': [{
              'color': this.currentActiveColorObj,
              'size': this.productDetails.sizes,
              'quantity': new Array(this.productDetails.sizes.length).fill(null),
              'verify_quantity': new Array(this.productDetails.sizes.length).fill(null),
              'price': new Array(this.productDetails.sizes.length).fill(null),
              'item_price': new Array(this.productDetails.sizes.length).fill(null),
              'impression_price': new Array(this.productDetails.sizes.length).fill(null),
              'total_price': new Array(this.productDetails.sizes.length).fill(null),
              'set_total_price': new Array(this.productDetails.sizes.length).fill(null),
            }]
          }];
        }
        else {
          var tmp_data = null;
          var tmp_key = null;
          var other_product = null;
          if (this.selectedColors.indexOf(this.currentActiveColor) < 0) {
            var selectedProductIds = this.projects.projects_data[this.activeProjectIndex]['products'].map(function (id) {
              return id.product_id;
            });
            var findProductIdIndex = selectedProductIds.indexOf(this.productDetails.product_id);

            if (findProductIdIndex >= 0) {
              let activeColor = this.currentActiveColor;
              let currentActiveColorObj = this.currentActiveColorObj;
              let productDetails = this.productDetails;
              this.projects.projects_data[this.activeProjectIndex]['products'][findProductIdIndex].matrix.forEach(function (ivalue, ikey) {

                if (ivalue.color.color_id != activeColor) {
                  tmp_key = findProductIdIndex;
                  tmp_data = {
                    'color': currentActiveColorObj,
                    'size': productDetails.sizes,
                    'quantity': new Array(productDetails.sizes.length).fill(null),
                    'verify_quantity': new Array(productDetails.sizes.length).fill(null),
                    'price': new Array(productDetails.sizes.length).fill(null),
                    'item_price': new Array(productDetails.sizes.length).fill(null),
                    'impression_price': new Array(productDetails.sizes.length).fill(null),
                    'total_price': new Array(productDetails.sizes.length).fill(null),
                    'set_total_price': new Array(productDetails.sizes.length).fill(null),
                  };
                }
              });
              other_product = null;
            }
            else {
              let pdesc = this.productDetails;
              other_product = {
                'product_id': this.productDetails.product_id,
                'productDetail': pdesc,
                'matrix': [{
                  'color': this.currentActiveColorObj,
                  'size': this.productDetails.sizes,
                  'quantity': new Array(this.productDetails.sizes.length).fill(null),
                  'verify_quantity': new Array(this.productDetails.sizes.length).fill(null),
                  'price': new Array(this.productDetails.sizes.length).fill(null),
                  'item_price': new Array(this.productDetails.sizes.length).fill(null),
                  'impression_price': new Array(this.productDetails.sizes.length).fill(null),
                  'total_price': new Array(this.productDetails.sizes.length).fill(null),
                  'set_total_price': new Array(this.productDetails.sizes.length).fill(null),
                }]
              };
            }
            if (tmp_data) {
              this.projects.projects_data[this.activeProjectIndex]['products'][tmp_key].matrix.push(tmp_data);
            }
            if (other_product) {
              let pdesc = this.productDetails;
              this.projects.projects_data[this.activeProjectIndex]['products'].push({
                'product_id': this.productDetails.product_id,
                'productDetail': pdesc,
                'matrix': [{
                  'color': this.currentActiveColorObj,
                  'size': this.productDetails.sizes,
                  'quantity': new Array(this.productDetails.sizes.length).fill(null),
                  'verify_quantity': new Array(this.productDetails.sizes.length).fill(null),
                  'price': new Array(this.productDetails.sizes.length).fill(null),
                  'item_price': new Array(this.productDetails.sizes.length).fill(null),
                  'impression_price': new Array(this.productDetails.sizes.length).fill(null),
                  'total_price': new Array(this.productDetails.sizes.length).fill(null),
                  'set_total_price': new Array(this.productDetails.sizes.length).fill(null),
                }]
              });
            }
          }
        }
      }
      if (this.selectedColors.length > 0) {

        if (this.selectedColors.indexOf(this.currentActiveColor) < 0) {
          this.selectedColors.push(this.currentActiveColor);
          this.isAlreadyExist = true;
        }
        if (isAlreadyExist) {
          let s_p_index = this.selectedColors.indexOf(this.currentActiveColor);
          this.selectedColors.splice(s_p_index, 1);
          this.isAlreadyExist = false;
          this.currentActiveColor = null;
        }
      }
      else {
        this.selectedColors[0] = this.currentActiveColor;
        this.isAlreadyExist = true;
      }
      if (this.selectedProductColors[this.activeProjectIndex]) {
        this.selectedProductColors[this.activeProjectIndex][this.currentProductId] = this.selectedColors;
      }
      else {
        this.selectedProductColors[this.activeProjectIndex] = { [this.currentProductId]: this.selectedColors };
      }
    }
  }

  handleNext() {
    if (this.productDetails && this.productDetails.product_id) {
      let selectedColorObj = (this.currentActiveColorObj && this.currentActiveColorObj.color_id) ? this.currentActiveColorObj : this.productDetails.colors[0];
      //If selectedColorObj's front_image is null, assign productDetails' style_image; otherwise, assign null.
      if (selectedColorObj) {
        if (selectedColorObj.front_image == null) {
          selectedColorObj.front_image = this.productDetails.style_image ? this.productDetails.style_image : null;
        }
      }
      let selectedColorId = (this.currentActiveColorObj && this.currentActiveColorObj.color_id) ? this.currentActiveColor : this.productDetails.colors[0].color_id;
      let matrix_id;
      const tempProductType = this.productDetails.type == 'quickItem' ? 'ssactivewear' : this.productDetails.type;
      this.productMatrix[tempProductType].forEach((value, key)=>{
        if(value.is_default=="1"){
          matrix_id = value.matrix_id;
        }
      });
      // Assign matrixId when selecting a Quick Item
      matrix_id = this.data.matrixId ? this.data.matrixId : matrix_id;

      if (!this.projects.projects_data[this.activeProjectIndex]['products']) {
        this.projects.projects_data[this.activeProjectIndex]['products'] = [{
          'product_id': this.productDetails.product_id,
          'productDetail': this.productDetails,
          'matrix': [{
            'color': selectedColorObj,
            'matrix_id': matrix_id,
            'size': this.productDetails.sizes,
            'quantity': new Array(this.productDetails.sizes.length).fill(null),
            'verify_quantity': new Array(this.productDetails.sizes.length).fill(null),
            'price': new Array(this.productDetails.sizes.length).fill(null),
            'item_price': new Array(this.productDetails.sizes.length).fill(null),
            'impression_price': new Array(this.productDetails.sizes.length).fill(null),
            'total_price': new Array(this.productDetails.sizes.length).fill(null),
            'set_total_price': new Array(this.productDetails.sizes.length).fill(null),
          }]
        }];
        this.selectedColors[0] = selectedColorId;
        this.CommonProjectDataService.storeSelectedColor(this.selectedColors);

        if (this.selectedProductColors[this.activeProjectIndex]) {
          this.selectedProductColors[this.activeProjectIndex][this.currentProductId] = this.selectedColors;
        }
        else {
          this.selectedProductColors[this.activeProjectIndex] = { [this.currentProductId]: this.selectedColors };
        }
        this.CommonProjectDataService.storeSelectedColor(this.selectedColors);
        this.CommonProjectDataService.storeProductColor(this.selectedProductColors);
        this.CommonProjectDataService.store(this.projects);

      }
      else {
        let selectedProductIds = this.projects.projects_data[this.activeProjectIndex]['products'].map(function (id) {
          return id.product_id;
        });

        let findProductIdIndex = selectedProductIds.indexOf(this.productDetails.product_id);
        if (findProductIdIndex < 0 && this.currentProductId == this.productDetails.product_id) {
          this.projects.projects_data[this.activeProjectIndex]['products'].push({
            'product_id': this.productDetails.product_id,
            'productDetail': this.productDetails,
            'matrix': [{
              'color': selectedColorObj,
              'matrix_id': matrix_id,
              'size': this.productDetails.sizes,
              'quantity': new Array(this.productDetails.sizes.length).fill(null),
              'verify_quantity': new Array(this.productDetails.sizes.length).fill(null),
              'price': new Array(this.productDetails.sizes.length).fill(null),
              'item_price': new Array(this.productDetails.sizes.length).fill(null),
              'impression_price': new Array(this.productDetails.sizes.length).fill(null),
              'total_price': new Array(this.productDetails.sizes.length).fill(null),
              'set_total_price': new Array(this.productDetails.sizes.length).fill(null),
            }]
          });
          this.selectedColors[0] = selectedColorId;
        }
        else {
          if (this.selectedColors.indexOf(selectedColorId) < 0) {
            let tmp_data = {
              'color': selectedColorObj,
              'matrix_id': matrix_id,
              'size': this.productDetails.sizes,
              'quantity': new Array(this.productDetails.sizes.length).fill(null),
              'verify_quantity': new Array(this.productDetails.sizes.length).fill(null),
              'price': new Array(this.productDetails.sizes.length).fill(null),
              'item_price': new Array(this.productDetails.sizes.length).fill(null),
              'impression_price': new Array(this.productDetails.sizes.length).fill(null),
              'total_price': new Array(this.productDetails.sizes.length).fill(null),
              'set_total_price': new Array(this.productDetails.sizes.length).fill(null),
            };

            this.projects.projects_data[this.activeProjectIndex]['products'][findProductIdIndex].matrix.push(tmp_data);
            let tmpColorArr = this.selectedProductColors[this.activeProjectIndex][this.productDetails.product_id];

            if (tmpColorArr.length > 0 && tmpColorArr.indexOf(selectedColorId) < 0) {
              tmpColorArr.push(selectedColorId);
            }
            else {
              tmpColorArr[0] = selectedColorId;
            }
            this.selectedColors = tmpColorArr;
          }
        }

        this.CommonProjectDataService.storeSelectedColor(this.selectedColors);
        if (this.selectedProductColors[this.activeProjectIndex]) {
          this.selectedProductColors[this.activeProjectIndex][this.currentProductId] = this.selectedColors;
        }
        else {
          this.selectedProductColors[this.activeProjectIndex] = { [this.currentProductId]: this.selectedColors };
        }
        this.CommonProjectDataService.storeProductColor(this.selectedProductColors);
        this.CommonProjectDataService.store(this.projects);
      }
      this.projects.projects_data[this.activeProjectIndex].selectedProductColors = this.selectedProductColors;
      if (this.productDetails) {
        this.dialogRef.close();
        if (this.orderStatus == 'Quote') { 
          if(this.isPublicQuoteCreation == true){
            this.router.navigate(["/builder/quote/product-quantity"]);
          }
          else{
            this.router.navigate(["/quote/product-quantity"]);
          }
        }
        else {
          this.router.navigate(["/invoices/product-quantity"]);
        }

      }

      if (this.selectedProductPrice[this.currentProductId]) {
        this.selectedProductPrice[this.currentProductId] = this.data.price;
      }
      else {
        this.selectedProductPrice = { [this.currentProductId]: this.data.price };
      }
      this.CommonProjectDataService.storeSelectedProductPrice(this.selectedProductPrice);
    }
  }

  showProductModel(): void {
    let styleImage = this.productDetails.style_image.replace('_fm.', '_fl.');
    styleImage = styleImage.replace('//cdnl.', '//cdnm.');
    const dialogRef = this.dialog.open(ProductModelPhotoComponent, {
      width: "500px",
      maxWidth: "none",
      disableClose: true,
      data: {
        modelImage: styleImage
      }
    });

    dialogRef.afterClosed().subscribe(result => {

    });

  }
  onPrint() {
    window.print();
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }
  showImage(image: any){
    if(image){
      image = image.replace('//cdnl.', '//cdnm.');
    }
    return image;
  }

  getFirstPrice(options) {
    if (options) {
      const firstKey = Object.keys(options)[0];
      if (firstKey) {
        const firstNestedKey = Object.keys(options[firstKey])[0];
        if (firstNestedKey) {
          return options[firstKey][firstNestedKey].price;
        }
      }
    }
    
    return 0;
  }
  
}





// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/product-detail/product-detail.component.ts